import dashboardIcon from "../../../../../assets/sideMenu/dashboardIcon.svg";
import dashboardSelectedIcon from "../../../../../assets/sideMenu/dashboardSelectedIcon.svg";
import myappointmentsIcon from "../../../../../assets/sideMenu/myappointmentsIcon.svg";
import myappointmentsSelectedIcon from "../../../../../assets/sideMenu/myappointmentsSelectedIcon.svg";
import mypatientsIcon from "../../../../../assets/sideMenu/mypatientsIcon.svg";
import mypatientsSelectedIcon from "../../../../../assets/sideMenu/mypatientsSelectedIcon.svg";
import webinarsIcon from "../../../../../assets/sideMenu/webinarsIcon.svg";
import webinarsSelectedIcon from "../../../../../assets/sideMenu/webinarsSelectedIcon.svg";
import patienteducationIcon from "../../../../../assets/sideMenu/patienteducationIcon.svg";
import patienteducationSelectedIcon from "../../../../../assets/sideMenu/patienteducationSelectedIcon.svg";
import c2cmedupdatesIcon from "../../../../../assets/sideMenu/c2cmedupdatesIcon.svg";
import c2cmedupdatesSelectedIcon from "../../../../../assets/sideMenu/c2cmedupdatesSelectedIcon.svg";
import patientcouponsIcon from "../../../../../assets/sideMenu/patientcouponsIcon.svg";
import patientcouponsSelectedIcon from "../../../../../assets/sideMenu/patientcouponsSelectedIcon.svg";
import messagesIcon from "../../../../../assets/sideMenu/messagesIcon.svg";
import messagesSelectedIcon from "../../../../../assets/sideMenu/messagesSelectedIcon.svg";
import mytransactionsIcon from "../../../../../assets/sideMenu/mytransactionsIcon.svg";
import mytransactionsSelectedIcon from "../../../../../assets/sideMenu/mytransactionsSelectedIcon.svg";
import myscheduleandfeesIcon from "../../../../../assets/sideMenu/myscheduleandfeesIcon.svg";
import myscheduleandfeesSelectedIcon from "../../../../../assets/sideMenu/myscheduleandfeesSelectedIcon.svg";
import settingsIcon from "../../../../../assets/sideMenu/settingsIcon.svg";
import settingsSelectedIcon from "../../../../../assets/sideMenu/settingsSelectedIcon.svg";
import helpandsupportIcon from "../../../../../assets/sideMenu/helpandsupportIcon.svg";
import helpandsupportSelectedIcon from "../../../../../assets/sideMenu/helpandsupportSelectedIcon.svg";
import logoutIcon from "../../../../../assets/sideMenu/logoutIcon.svg";
import logoutSelectedIcon from "../../../../../assets/sideMenu/logoutSelectedIcon.svg";
import queueMonitorIcon from "../../../../../assets/sideMenu/queueMonitor.svg";
import queueMonitorSelectedIcon from "../../../../../assets/sideMenu/queueMonitorSelected.svg";
import followUpIcon from "../../../../../assets/sideMenu/followUpGrey.svg";
import followUpSelectedIcon from "../../../../../assets/sideMenu/followUpBlue.svg";
import { LOCALSTORAGEKEY } from "../../../../../Util/Helper/localStorageUtils";
import { setDynamicCookieForUser } from "../../../../../Util/API Calls/cookieHelper";
import { USER_ROLE } from "../../../../../Util/constants";
import { PROD } from "../../../config";

const APPLICABLE_ROLE = {
  DOCTOR: "doctor",
  STAFF: "staff",
};

const APPLICABLE_SUB_ROLE = {
  DOCTORADMIN: "Administrator",
};

export const SIDE_MENU_IMAGES = {
  DASHBOARD_IMAGE: dashboardIcon,
  MYAPPOINTMENT_IMAGE: myappointmentsIcon,
  MYPATIENTS_IMAGE: mypatientsIcon,
  WEBINARS_IMAGE: webinarsIcon,
  PATIENTEDUCATION_IMAGE: patienteducationIcon,
  C2CMEDUPDATES_IMAGE: c2cmedupdatesIcon,
  PATIENTCOUPONS_IMAGE: patientcouponsIcon,
  MESSAGES_IMAGE: messagesIcon,
  MYTRANSACTIONS_IMAGE: mytransactionsIcon,
  MYSCHEDULEANDFEES_IMAGE: myscheduleandfeesIcon,
  SETTINGS_IMAGE: settingsIcon,
  HELPANDSUPPORT_IMAGE: helpandsupportIcon,
  LOGOUT_IMAGE: logoutIcon,
  QUEUE_MONITOR_IMAGE: queueMonitorIcon,
  FOLLOW_UP_IMAGE: followUpIcon,
};

export const SIDE_MENU_SELECTED_IMAGES = {
  DASHBOARD_SELECTED_IMAGE: dashboardSelectedIcon,
  MYAPPOINTMENT_SELECTED_IMAGE: myappointmentsSelectedIcon,
  MYPATIENTS_SELECTED_IMAGE: mypatientsSelectedIcon,
  WEBINARS_SELECTED_IMAGE: webinarsSelectedIcon,
  PATIENTEDUCATION_SELECTED_IMAGE: patienteducationSelectedIcon,
  C2CMEDUPDATES_SELECTED_IMAGE: c2cmedupdatesSelectedIcon,
  PATIENTCOUPONS_SELECTED_IMAGE: patientcouponsSelectedIcon,
  MESSAGES_SELECTED_IMAGE: messagesSelectedIcon,
  MYTRANSACTIONS_SELECTED_IMAGE: mytransactionsSelectedIcon,
  MYSCHEDULEANDFEES_SELECTED_IMAGE: myscheduleandfeesSelectedIcon,
  SETTINGS_SELECTED_IMAGE: settingsSelectedIcon,
  HELPANDSUPPORT_SELECTED_IMAGE: helpandsupportSelectedIcon,
  LOGOUT_SELECTED_IMAGE: logoutSelectedIcon,
  QUEUE_MONITOR_SELECTED_IMAGE: queueMonitorSelectedIcon,
  FOLLOW_UP_SELECTED_IMAGE: followUpSelectedIcon,
};

export const TITLES = {
  DASHBOARD: "Dashboard",
  MYPATIENTS: "My Patients",
  WEBINARS: "Webinars",
  PATIENTEDUCATION: "Patient Education",
  C2CMEDUPDATES: "C2C Med Updates",
  PATIENTCOUPONS: "Patient Coupons",
  MESSAGES: "Messages",
  MYTRANSACTIONS: "My Transactions",
  MYSCHEDULEANDFEES: "My Schedule & Fees",
  SETTINGS: "Settings",
  HELPANDSUPPORT: "Help & Support",
  LOGOUT: "Logout",
  QUEUE_MONITORING_DASHBOARD: "Queue Monitoring Dashboard",
  // NEWC2CMEDUPDATES:"C2C Med Updates New"
  FOLLOW_UP_DASHBOARD: "Follow-Up Dashboard",
};

export const SIDE_MENU_PATHS = {
  DASHBOARD: "dashboard",
  MYPATIENTS: "mypatients",
  WEBINARS: "webinars",
  PATIENTEDUCATION: "patienteducation",
  C2CMEDUPDATES: "medupdates",
  PATIENTCOUPONS: "rewards",
  MESSAGES: "messages",
  MYTRANSACTIONS: "mytransactions",
  MYSCHEDULEANDFEES: "myschedulefees2",
  SETTINGS: "settings",
  HELPANDSUPPORT: "help",
  LOGOUT: "logout",
  QUEUE_MONITORING_DASHBOARD: "queue-monitor",
  // NEWC2CMEDUPDATES:"meupdatesnew"
  FOLLOW_UP_DASHBOARD: "follow-up-dashboard",
};

// Dictionary definition
// {
//   id: 1, // unique id for each dictionary element
//   display_order: 1, // display_order will define the order of list from 1...inf
//   title: TITLES.DASHBOARD, // title of menu
//   icon: dashboardIcon, // icon of menu
//   selected_icon: dashboardSelectedIcon, // this icon will be shown in selected state
//   path: SIDE_MENU_PATHS.DASHBOARD, // this is the end path of url
//   applicable_roles: [APPLICABLE_ROLE.DOCTOR, APPLICABLE_ROLE.STAFF], // this array will define for how many types of users we have to show this element
//   disabled_for_partial_doctor: false, // this key is related to partial doctor, if any user is partial doctor then according to this key we will disable element
// },

export const sideMenuList = [
  {
    id: 1,
    display_order: 1,
    title: TITLES.DASHBOARD,
    icon: SIDE_MENU_IMAGES.DASHBOARD_IMAGE,
    selected_icon: SIDE_MENU_SELECTED_IMAGES.DASHBOARD_SELECTED_IMAGE,
    path: SIDE_MENU_PATHS.DASHBOARD,
    applicable_roles: [APPLICABLE_ROLE.DOCTOR, APPLICABLE_ROLE.STAFF],
    disabled_for_partial_doctor: false,
  },
  {
    id: 2,
    display_order: 2,
    title: TITLES.QUEUE_MONITORING_DASHBOARD,
    icon: SIDE_MENU_IMAGES.QUEUE_MONITOR_IMAGE,
    selected_icon: SIDE_MENU_SELECTED_IMAGES.QUEUE_MONITOR_SELECTED_IMAGE,
    path: SIDE_MENU_PATHS.QUEUE_MONITORING_DASHBOARD,
    applicable_roles: [APPLICABLE_ROLE.DOCTOR, APPLICABLE_ROLE.STAFF],
    disabled_for_partial_doctor: true,
  },
  {
    id: 3,
    display_order: 3,
    title: TITLES.FOLLOW_UP_DASHBOARD,
    icon: SIDE_MENU_IMAGES.FOLLOW_UP_IMAGE,
    selected_icon: SIDE_MENU_SELECTED_IMAGES.FOLLOW_UP_SELECTED_IMAGE,
    path: SIDE_MENU_PATHS.FOLLOW_UP_DASHBOARD,
    applicable_roles: [APPLICABLE_ROLE.DOCTOR, APPLICABLE_ROLE.STAFF],
    disabled_for_partial_doctor: true,
  },
  {
    id: 4,
    display_order: 4,
    title: TITLES.MYPATIENTS,
    icon: SIDE_MENU_IMAGES.MYPATIENTS_IMAGE,
    selected_icon: SIDE_MENU_SELECTED_IMAGES.MYPATIENTS_SELECTED_IMAGE,
    path: SIDE_MENU_PATHS.MYPATIENTS,
    applicable_roles: [APPLICABLE_ROLE.DOCTOR, APPLICABLE_ROLE.STAFF],
    disabled_for_partial_doctor: true,
  },
  {
    id: 5,
    display_order: 5,
    title: TITLES.WEBINARS,
    icon: SIDE_MENU_IMAGES.WEBINARS_IMAGE,
    selected_icon: SIDE_MENU_SELECTED_IMAGES.WEBINARS_SELECTED_IMAGE,
    path: SIDE_MENU_PATHS.WEBINARS,
    applicable_roles: [APPLICABLE_ROLE.DOCTOR],
    disabled_for_partial_doctor: false,
  },
  {
    id: 6,
    display_order: 6,
    title: TITLES.PATIENTEDUCATION,
    icon: SIDE_MENU_IMAGES.PATIENTEDUCATION_IMAGE,
    selected_icon: SIDE_MENU_SELECTED_IMAGES.PATIENTEDUCATION_SELECTED_IMAGE,
    path: SIDE_MENU_PATHS.PATIENTEDUCATION,
    applicable_roles: [APPLICABLE_ROLE.DOCTOR],
    disabled_for_partial_doctor: true,
  },
  {
    id: 7,
    display_order: 7,
    title: TITLES.C2CMEDUPDATES,
    icon: SIDE_MENU_IMAGES.C2CMEDUPDATES_IMAGE,
    selected_icon: SIDE_MENU_SELECTED_IMAGES.C2CMEDUPDATES_SELECTED_IMAGE,
    path: SIDE_MENU_PATHS.C2CMEDUPDATES,
    applicable_roles: [APPLICABLE_ROLE.DOCTOR],
    disabled_for_partial_doctor: false,
  },
  // 17922 ==>
  // {
  //   id: 8,
  //   display_order: 8,
  //   title: TITLES.PATIENTCOUPONS,
  //   icon: SIDE_MENU_IMAGES.PATIENTCOUPONS_IMAGE,
  //   selected_icon: SIDE_MENU_SELECTED_IMAGES.PATIENTCOUPONS_SELECTED_IMAGE,
  //   path: SIDE_MENU_PATHS.PATIENTCOUPONS,
  //   applicable_roles: [APPLICABLE_ROLE.DOCTOR, APPLICABLE_ROLE.STAFF],
  //   disabled_for_partial_doctor: true,
  // },
  // <==
  {
    id: 9,
    display_order: 9,
    title: TITLES.MESSAGES,
    icon: SIDE_MENU_IMAGES.MESSAGES_IMAGE,
    selected_icon: SIDE_MENU_SELECTED_IMAGES.MESSAGES_SELECTED_IMAGE,
    path: SIDE_MENU_PATHS.MESSAGES,
    applicable_roles: [APPLICABLE_ROLE.DOCTOR, APPLICABLE_ROLE.STAFF],
    disabled_for_partial_doctor: true,
  },
  {
    id: 10,
    display_order: 10,
    title: TITLES.MYTRANSACTIONS,
    icon: SIDE_MENU_IMAGES.MYTRANSACTIONS_IMAGE,
    selected_icon: SIDE_MENU_SELECTED_IMAGES.MYTRANSACTIONS_SELECTED_IMAGE,
    path: SIDE_MENU_PATHS.MYTRANSACTIONS,
    applicable_roles: [APPLICABLE_ROLE.DOCTOR, APPLICABLE_ROLE.STAFF],
    disabled_for_partial_doctor: true,
  },
  {
    id: 11,
    display_order: 11,
    title: TITLES.MYSCHEDULEANDFEES,
    icon: SIDE_MENU_IMAGES.MYSCHEDULEANDFEES_IMAGE,
    selected_icon: SIDE_MENU_SELECTED_IMAGES.MYSCHEDULEANDFEES_SELECTED_IMAGE,
    path: SIDE_MENU_PATHS.MYSCHEDULEANDFEES,
    applicable_roles: [APPLICABLE_ROLE.DOCTOR, APPLICABLE_ROLE.STAFF],
    disabled_for_partial_doctor: true,
  },
  {
    id: 12,
    display_order: 12,
    title: TITLES.SETTINGS,
    icon: SIDE_MENU_IMAGES.SETTINGS_IMAGE,
    selected_icon: SIDE_MENU_SELECTED_IMAGES.SETTINGS_SELECTED_IMAGE,
    path: SIDE_MENU_PATHS.SETTINGS,
    applicable_roles: [APPLICABLE_ROLE.DOCTOR, APPLICABLE_ROLE.STAFF],
    disabled_for_partial_doctor: true,
  },
  {
    id: 13,
    display_order: 13,
    title: TITLES.HELPANDSUPPORT,
    icon: SIDE_MENU_IMAGES.HELPANDSUPPORT_IMAGE,
    selected_icon: SIDE_MENU_SELECTED_IMAGES.HELPANDSUPPORT_SELECTED_IMAGE,
    path: SIDE_MENU_PATHS.HELPANDSUPPORT,
    applicable_roles: [APPLICABLE_ROLE.DOCTOR, APPLICABLE_ROLE.STAFF],
    disabled_for_partial_doctor: false,
  },
  // {
  //   id: 14,
  //   display_order: 14,
  //   title: TITLES.NEWC2CMEDUPDATES,
  //   icon: SIDE_MENU_IMAGES.C2CMEDUPDATES_IMAGE,
  //   selected_icon: SIDE_MENU_SELECTED_IMAGES.C2CMEDUPDATES_SELECTED_IMAGE,
  //   path: SIDE_MENU_PATHS.NEWC2CMEDUPDATES,
  //   applicable_roles: [APPLICABLE_ROLE.DOCTOR],
  //   disabled_for_partial_doctor: false,
  // },
];

export const sideMenuRenderList = (
  user_type,
  setCookie,
  enableLeadsDashboard
) => {
  let userRole = localStorage.getItem(LOCALSTORAGEKEY.DOCTOR_ROLE);
  let userType = localStorage.getItem(LOCALSTORAGEKEY.USER_TYPE);
  let clinicId = localStorage.getItem(LOCALSTORAGEKEY.CLINIC_ID);

  let tempSideMenu = [...sideMenuList];
  if (
    (userType === APPLICABLE_ROLE.DOCTOR &&
      userRole !== APPLICABLE_SUB_ROLE.DOCTORADMIN) ||
    (userType === APPLICABLE_ROLE.STAFF && !clinicId)
  ) {
    let index = tempSideMenu.findIndex(
      (menu) => menu.title === TITLES.QUEUE_MONITORING_DASHBOARD
    );
    if (index > -1) {
      tempSideMenu.splice(index, 1);
      setDynamicCookieForUser("showQueueMonitoringDashboard", false, setCookie);
    }
  } else {
    setDynamicCookieForUser("showQueueMonitoringDashboard", true, setCookie);
  }

  let followUpDashboardInd = tempSideMenu.findIndex(
    (menu) => menu.title === TITLES.FOLLOW_UP_DASHBOARD
  );

  if (
    !enableLeadsDashboard ||
    userRole === USER_ROLE.DOCTOR_CONSULTANT ||
    userRole === USER_ROLE.RESOURCE_CONSULTANT ||
    !clinicId
  ) {
    if (followUpDashboardInd > -1) {
      setDynamicCookieForUser("showFollowUpDashboard", false, setCookie);
      tempSideMenu.splice(followUpDashboardInd, 1);
    }
  } else {
    setDynamicCookieForUser("showFollowUpDashboard", true, setCookie);
  }

  return tempSideMenu.filter(
    (menu) => menu.applicable_roles.indexOf(user_type) !== -1
  );
};
